module.exports = { id: "alert", url: "/build/app/img/symbols.svg#alert", viewBox: "", toString: function() { return this.url; } };